<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Menu</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

            <template slot="body">
                <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{lista.Menu}}</h6></td>
                    <td class="align-middle text-end">
                        <CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="lista.IdNotificacionConfig" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
                            <template slot="btnaccion">
                                <CMoreButtonsL>
                                    <template slot="bodyBtnsL">
                                        <li @click="IraNotificacionesDetalle(lista)">
                                            <a class="dropdown-item">
                                                <i class="far fa-bell"></i> Ver notificaciones de submenus
                                            </a>
                                        </li>
                                    </template>
                                </CMoreButtonsL>
                            </template>
                        </CBtnAccion>
                    </td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="3"></CSinRegistros>
            </template>
        </CList>

        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>
    </div>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
import Form from '@/views/catalogos/notificacion/Form.vue';
const EmitEjecuta = 'seccionNotificacionConfig';
export default {
    name: 'Notificaciones',
    props: ['sFiltros','pOrigen'],
    components: {
        Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Notificaciones',
                IsModal: true,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: '',
            },
            Filtro:{
                Nombre:'',
                Entrada:25,
                Pagina:1,
                TotalItem:0,
                Placeholder: 'Buscar..',
            },
            ConfigModal:{
                ModalTitle: "Notificación",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
        async Lista(){
            this.ConfigList.ShowLoader = true;
            this.$http.get('notificacionesConfig',{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }
            ).then((res)=>{
                this.ListaArrayRows     = res.data.data.data;
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            })
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('notificacionesConfig/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus',params:{}});
        },
        IraNotificacionesDetalle(item){
            this.$router.push({name:'notificacionesConfigDetalle',params:{objEnviado:item}});
        }
    },
    created() {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }
        
        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted() {
        this.Lista();

        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>

<style>

</style>